module.exports = __webpack_public_path__ + "img/ae.4d913fc2.svg";